<template>
  <v-dialog v-model="value" max-width="1200px" persistent>
    <template>
      <v-card color="primary" dark v-if="isLoadingEdit">
        <v-card-text>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
      <v-container fluid class="px-0 py-4 addClientsModal" style="background: #fff" v-else>
        <ValidationObserver ref="form" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="12" class="py-0">
              <h4 class="display-2 primary--text font-weight-bold text-center text-uppercase">
                <span v-if="!id">AJOUTER UNE FICHE CLIENT</span>
                <span v-else>ÉDITER LA FICHE CLIENT</span>
              </h4>
              <v-divider class="my-3 mb-2"></v-divider>
            </v-col>
          </v-row>
          <v-form class="px-6">
            <v-row>
              <v-col cols="12" class="py-1">
                <div class="d-flex align-center">
                  <img src="assets/img/logo.png" width="22" />
                  <span
                    class="display-1 primary--text font-weight-bold ml-3 pt-1"
                  >Information Générale</span>
                </div>
              </v-col>
              <v-col style="max-width: 160px">
                <ImagePickerInput v-model="form.logoFile" :image-placeholder="form.logoUrl"></ImagePickerInput>
              </v-col>

              <v-col>
                <v-row>
                  <v-col cols="3" class="py-1 px-0 ml-1">
                    <ValidationObserver ref="companyname" v-slot="{ validate, reset }">
                      <p class="label">{{$t('Client company name')}}</p>
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('Client company name')"
                        rules="required"
                      >
                        <v-text-field
                          hide-details="auto"
                          v-model="form.name"
                          outlined
                          required
                          :error-messages="errors"
                          class="mb-4"
                        ></v-text-field>
                      </ValidationProvider>
                    </ValidationObserver>
                  </v-col>

                  <v-col style="white-space: nowrap;" cols="3" class="py-1 px-0 ml-4">
                    <p class="label">Date de création</p>
                    <p class="mb-2 mt-3">
                      <v-icon v-text="'$clock'" class="mr-2"></v-icon>
                      {{ form.createdAt | moment('DD/MM/YYYY') }}
                    </p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-card flat class="mt-0 mx-auto px-1">
                      <v-card-text class="pa-0">
                        <ValidationObserver ref="location" v-slot="{ validate, reset }">
                          <v-row
                            class="client-contact-row mb-3"
                            v-for="(location, index) in getClientLocations"
                            :key="index"
                          >
                            <v-col class="py-1">
                              <v-row class="px-4">
                                <v-col cols="2" class="py-1">
                                  <v-card flat class="mt-0 mx-auto px-1">
                                    <v-card-text class="pa-0 mb-1">
                                      <p class="label">{{$t('Identite facturable')}}</p>

                                      <ValidationProvider
                                        v-slot="{ errors }"
                                        :name="$t('Identity company')"
                                        rules="required"
                                      >
                                        <v-text-field
                                          hide-details="auto"
                                          v-model="location.identity"
                                          ref="input1"
                                          :disabled="location.disabled"
                                          outlined
                                          required
                                          :error-messages="errors"
                                        ></v-text-field>
                                      </ValidationProvider>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                <v-col cols="2" class="py-1">
                                  <v-card flat class="mt-0 mx-auto px-1">
                                    <v-card-text class="pa-0 mb-1">
                                      <p class="label">Ville</p>
                                      <v-text-field
                                        v-model="location.city"
                                        hide-details="auto"
                                        outlined
                                        required
                                        :disabled="location.disabled"
                                      ></v-text-field>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                <v-col cols="2" class="py-1">
                                  <v-card flat class="mt-0 mx-auto px-1">
                                    <v-card-text class="pa-0 mb-1">
                                      <p class="label">CP</p>
                                      <v-text-field
                                        v-model="location.codePostal"
                                        hide-details="auto"
                                        outlined
                                        required
                                        :disabled="location.disabled"
                                      ></v-text-field>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                <v-col cols="3" class="py-1">
                                  <v-card flat class="mt-0 mx-auto px-1">
                                    <v-card-text class="pa-0 mb-1">
                                      <p class="label">Address</p>
                                      <v-text-field
                                        v-model="location.address"
                                        hide-details="auto"
                                        outlined
                                        required
                                        :disabled="location.disabled"
                                      ></v-text-field>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                <v-col class="py-1">
                                  <v-card flat class="mt-0 mx-auto px-1">
                                    <v-card-text class="pa-0 mb-1">
                                      <p class="label">Pays</p>
                                      <CountryPickerInput
                                        v-model="location.countryId"
                                        :disabled="location.disabled"
                                      ></CountryPickerInput>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col class="pa-0" style="max-width: 36px;">
                              <div class="client-contact-actions d-flex flex-column justify-center">
                                <v-btn
                                  icon
                                  v-if="!location.id"
                                  @click="addLocation(location.identity, index)"
                                  title="Sauvegarder"
                                >
                                  <v-icon color="#47266F" class="fal fa-check fa-lg"></v-icon>
                                </v-btn>

                                <v-btn
                                  icon
                                  v-if="location.id && location.disabled == true"
                                  @click="editLocation(location)"
                                  title="Éditer"
                                >
                                  <v-icon color="#47266F" class="fal fa-edit fa-lg"></v-icon>
                                </v-btn>

                                <v-btn
                                  icon
                                  v-if="location.id && location.disabled == false"
                                  @click="editLocation(location, true)"
                                  title="Sauvegarder"
                                >
                                  <v-icon color="#47266F" class="fal fa-check fa-lg"></v-icon>
                                </v-btn>

                                <v-btn
                                  icon
                                  v-if="location.id"
                                  @click="deleteLocation(location.identity)"
                                  title="Supprimer"
                                >
                                  <v-icon color="#47266F" class="fal fa-trash-alt fa-lg"></v-icon>
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          

            <v-divider class="my-3 mb-2"></v-divider>
            <v-row>
              <v-col cols="12" class="py-1">
                <div class="d-flex align-center">
                  <img src="assets/img/logo.png" width="22" />
                  <span class="display-1 primary--text font-weight-bold ml-3 pt-1">Contact</span>
                </div>
              </v-col>
              <v-col cols="12">
                <ValidationObserver ref="contact" v-slot="{ validate, reset }">
                  <v-row
                    class="client-contact-row mb-3"
                    v-for="(contact, index) in getClientContacts"
                    :key="index"
                  >
                    <v-col style="max-width: 180px">
                      <v-card flat class="mt-0 mx-auto px-1">
                        <v-card-text class="pa-0 mb-1">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :name="$t('Gender')"
                            rules="required"
                          >
                            <p class="label pl-2">Civilité</p>
                            <v-radio-group
                              v-model="form.clientContacts[index].gender"
                              row
                              required
                              :disabled="contact.disabled"
                              class="mt-2"
                              hide-details
                              :error-messages="errors"
                            >
                              <v-radio label="M." :value="1"></v-radio>
                              <v-radio label="Mme." :value="0" class="mr-0"></v-radio>
                            </v-radio-group>
                          </ValidationProvider>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="2">
                      <v-card flat class="mt-0 mx-auto px-1">
                        <v-card-text class="pa-0">
                          <p class="label">{{$t('Full name')}}</p>
                          <ValidationProvider
                            v-slot="{ errors }"
                            :name="$t('Full name')"
                            rules="required"
                          >
                            <v-text-field
                              v-model="form.clientContacts[index].name"
                              hide-details="auto"
                              outlined
                              required
                              :error-messages="errors"
                              class="mb-3"
                              :disabled="contact.disabled"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="2">
                      <v-card flat class="mt-0 mx-auto px-1">
                        <v-card-text class="pa-0">
                          <p class="label">{{$t('Email')}}</p>
                          <ValidationProvider
                            v-slot="{ errors }"
                            :name="$t('Email')"
                            rules="required|email"
                          >
                            <v-text-field
                              v-model="form.clientContacts[index].email"
                              hide-details="auto"
                              outlined
                              required
                              :error-messages="errors"
                              class="mb-3"
                              :disabled="contact.disabled"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col>
                      <v-card flat class="mt-0 mx-auto px-1">
                        <v-card-text class="pa-0">
                          <p class="label">{{$t('Telephone fix')}}</p>
                          <v-text-field
                            v-model="form.clientContacts[index].telephone"
                            hide-details="auto"
                            outlined
                            required
                            class="mb-3"
                            :disabled="contact.disabled"
                          ></v-text-field>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col class="pr-0">
                      <v-card flat class="mt-0 mx-auto px-1">
                        <v-card-text class="pa-0">
                          <p class="label">Mobile</p>
                          <v-text-field
                            v-model="form.clientContacts[index].mobile"
                            hide-details="auto"
                            outlined
                            required
                            class="mb-3"
                            :disabled="contact.disabled"
                          ></v-text-field>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col class="pa-0" style="max-width: 36px;">
                      <div class="client-contact-actions d-flex flex-column justify-center">
                        <v-btn
                          icon
                          v-if="contact.id && contact.disabled == true"
                          @click="editContact(contact)"
                          title="Éditer"
                        >
                          <v-icon color="#47266F" class="fal fa-edit fa-lg"></v-icon>
                        </v-btn>

                        <v-btn
                          icon
                          v-if="contact.id && contact.disabled == false"
                          @click="editContact(contact, true)"
                          title="Sauvegarder"
                        >
                          <v-icon color="#47266F" class="fal fa-check fa-lg"></v-icon>
                        </v-btn>

                        <v-btn
                          icon
                          v-if="contact.id"
                          @click="deleteContact(contact.id)"
                          title="Supprimer"
                        >
                          <v-icon color="#47266F" class="fal fa-trash-alt fa-lg"></v-icon>
                        </v-btn>

                        <v-btn
                          icon
                          v-if="!contact.id"
                          @click="addContact(contact.name, index)"
                          title="Sauvegarder"
                        >
                          <v-icon color="#47266F" class="fal fa-check fa-lg"></v-icon>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-col>
            </v-row>

            <v-row>
              <div class="col text-center">
                <v-btn
                  class="ma-2"
                  depressed
                  rounded
                  color="primary"
                  @click="save"
                  :loading="isLoading"
                >
                  <span v-if="id">{{$t('Save')}}</span>
                  <span v-else>Enregistrer</span>
                </v-btn>
                <v-btn
                  class="ma-2 black--text"
                  depressed
                  rounded
                  color="#E1E1E1"
                  @click="closeModal"
                >Annuler</v-btn>
              </div>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-container>
    </template>
  </v-dialog>
</template>

<script>
import ClientService from "@/services/client.service.js";
import CountryPickerInput from "@/components/inputs/CountryPickerInput.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ImagePickerInput from "@/components/inputs/ImagePickerInput.vue";

export default {
  name: "AddClientForm",
  components: {
    CountryPickerInput,
    ValidationObserver,
    ValidationProvider,
    ImagePickerInput
  },
  props: {
    value: {},
    id: {},
    addClient: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoadingEdit: false,
    isLoading: false,
    disabled: null,
    form: {
      name: "",
      logoFile: null,
      createdAt: null,
      clientContacts: [],
      clientLocations: []
    },
    counter: 0,
    temp: {},
    arrayId: []
  }),
  created() {
    this.form = ClientService.getInitFormData();
  },
  computed: {
    getClientLocations() {
      const count = this.counter;
      return this.form.clientLocations;
    },
    getClientContacts() {
      const count = this.counter;
      return this.form.clientContacts;
    }
  },
  methods: {
    editLocation(location, finish = false) {
      location.disabled = finish == true ? true : false;
      this.counter++;
    },
    editContact(contact, finish = false) {
      contact.disabled = finish == true ? true : false;
      this.counter++;
    },
    editContact(contact, finish = false) {
      contact.disabled = finish == true ? true : false;
      this.counter++;
    },
    async addLocation(identity, idx) {
      const success = await this.$refs.location.validate();
      if (!success) {
        this.isLoading = false;
        return;
      }
      let index = this.form.clientLocations.findIndex(
        u => u.identity == identity
      );
      if (index != -1) {
        this.form.clientLocations[index].id = -idx - 1;
        this.form.clientLocations[index].disabled = true;
      }

      this.form.clientLocations.push(ClientService.getInitLocation());
    },
    async addContact(name, idx) {
      const success = await this.$refs.contact.validate();
      if (!success) {
        this.isLoading = false;
        return;
      }
      let index = this.form.clientContacts.findIndex(u => u.name == name);
      if (index > -1) {
        this.form.clientContacts[index].id = -idx - 1;
        this.form.clientContacts[index].disabled = true;
      }
      this.form.clientContacts.push(ClientService.getInitContact());
    },
    deleteContact(id) {
      let index = this.form.clientContacts.findIndex(u => u.id == id);
      if (index > -1) {
        this.form.clientContacts.splice(index, 1);
      }
    },
    deleteLocation(identity) {
      let index = this.form.clientLocations.findIndex(
        u => u.identity == identity
      );
      if (index > -1) {
        this.form.clientLocations.splice(index, 1);
      }
    },
    closeModal() {
      this.$refs.form.reset();
      this.$emit("input", false);
      this.form = ClientService.getInitFormData();
    },
    assignToForm(data) {
      this.form = Object.assign(this.form, data);

      this.form.clientContacts.forEach(element => {
        element.disabled = true;
      });

      this.form.clientLocations.forEach(element => {
        element.disabled = true;
      });

      this.form.clientContacts.push(ClientService.getInitContact());
      this.form.clientLocations.push(ClientService.getInitLocation());
    },
    async save() {
      try {
        if (this.isLoading) {
          return;
        }

        const success = await this.$refs.companyname.validate();
        if (!success) {
          this.isLoading = false;
          return;
        }

        this.isLoading = true;

        this.form.clientLocations.splice(
          this.form.clientLocations.findIndex(e => e.identity == ""),
          1
        );

        this.form.clientContacts.splice(
          this.form.clientContacts.findIndex(
            e => e.name == "" && e.email == ""
          ),
          1
        );

        if (this.id) {
          await ClientService.update(this.id, this.form);
          this.successMessage(this.$t("Client updated successfully"));
          this.$emit("update:item-added", this.id);
        } else {
          this.form.clientContacts = Object.values(this.form.clientContacts);
          const { data } = await ClientService.create(this.form);
          this.successMessage(this.$t("Client created successfully"));
          this.$emit("update:item-added", data.id);
        }

        this.closeModal();
      } catch (e) {
        this.handleError(e);
      }

      this.isLoading = false;
      this.$emit("add-client-search");
    },
    async loadEdit() {
      const { data } = await ClientService.getById(this.id);
      this.isLoadingEdit = false;

      this.assignToForm(data);
    }
  },
  watch: {
    value: {
      handler(value) {
        this.isLoadingEdit = false;
        if (!value) {
          return;
        }

        // If mode edit
        if (this.id) {
          this.isLoadingEdit = true;
          this.loadEdit();
        }
      }
    }
  }
};
</script>
